import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthEffects } from './core/ngrx/effect/auth.effect';
import { metaReducers, reducers } from './reducers';
import { APP_CONFIG } from './core/tokens/app-config.token';
import { config } from '../environments/config';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DnInterceptorService } from './core/interceptor/dn-interceptor.service';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { AuthenticationGuard } from './core/guard/authentication.guard';
import { DatanyzeCommonModule, CookieConsentService } from '@dn/libs/ui/dn-common';

const imports = [
  AngularCommonModule,
  BrowserModule,
  AppRoutingModule,
  EffectsModule.forRoot([AuthEffects]),
  StoreRouterConnectingModule.forRoot(),
  StoreModule.forRoot(reducers, {
    metaReducers,
    runtimeChecks: {
      strictStateImmutability: true,
      strictActionImmutability: true,
    },
  }),
  BrowserAnimationsModule,
  DatanyzeCommonModule,
];

if (!config.production) {
  imports.push(StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: config.production }));
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports,
  providers: [
    AuthenticationGuard,
    CookieConsentService,
    { provide: APP_CONFIG, useValue: config },
    { provide: 'baseUrl', useValue: config.identity_backend_url },
    { provide: 'isProd', useValue: config.production },
    { provide: HTTP_INTERCEPTORS, useClass: DnInterceptorService, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    provideClientHydration(withEventReplay()),
  ],
})
export class AppModule {}
